namespace RioERP.Web.Enums {
    export enum BankAccountType {
        Current = 1,
        Saving = 2
    }
    Serenity.Decorators.registerEnumType(BankAccountType, 'RioERP.Web.Enums.BankAccountType');
}
